/* eslint-disable import/prefer-default-export */
import { attach } from './attach';
import { str, func, dom } from '../../../util';

const getStylePropertyValue = (decl, property) => {
  return decl.getPropertyValue(property);
};

const configRE = /((?:\d?\.)?\d+(?:ms|s))\s([\s\S]+)/;
const parseConfig = (config) => {
  const [, duration, easing] = config.match(configRE);
  return {
    duration,
    easing,
  };
};

const numberifyDuration = (duration) => {
  if (/ms$/.test(duration)) {
    return parseFloat(duration.slice(0, -2));
  } else if (/s$/.test(duration)) {
    return parseFloat(duration.slice(0, -1)) * 1000;
  } else {
    throw new Error('Numberify duration failed.');
  }
};

export const motion = (config, initial, end, delay) => {
  let duration;
  let easing;

  if (typeof config === 'number') {
    duration = config.toString();
  } else {
    const ret = parseConfig(config);
    duration = ret.duration;
    easing = ret.easing || 'ease';
  }

  if (duration == null) {
    throw new Error('transition duration should be specified.');
  }

  return (el, callback) => {
    const orginStyle = el.getAttribute('style');
    const currentStyle = {};
    const computedStyle = window.getComputedStyle(el);
    const transitionRule = [];
    let hiddenRule = '';

    for (const i in initial) {
      if (Object.prototype.hasOwnProperty.call(initial, i) && initial[i] != null) {
        const propertyName = str.hyphenate(i);
        transitionRule.push(`${propertyName} ${duration} ${easing}`);
        currentStyle[i] = getStylePropertyValue(computedStyle, propertyName);

        if (i === 'height') {
          hiddenRule = hiddenRule || 'overflow: hidden;';
          el.style['overflow'] = 'hidden';
        }

        if (initial[i] === '*') {
          el.style[i] = currentStyle[i];
        } else {
          el.style[i] = initial[i];
        }
      }
    }

    // 强制触发重排以保证动画的执行
    dom.forceReflow(el);

    const run = (motionToken) => {
      el.style.cssText = `
        ${orginStyle}; transition: ${transitionRule.join(', ')}; ${hiddenRule}
      `;

      for (const i in end) {
        if (end.hasOwnProperty(i) && end[i] != null) {
          if (end[i] === '*') {
            el.style[i] = currentStyle[i];
          } else {
            el.style[i] = end[i];
          }
        }
      }

      attach(el, orginStyle, numberifyDuration(duration), motionToken)
        .then(() => callback())
        .catch((err) => {
          if (!err.canceled) {
            callback();
          }
        });

      return () => {
        if (motionToken && func.isFunction(motionToken.cancel)) {
          motionToken.cancel();
        }
      };
    };

    const token = Object.create(null);

    if (typeof delay === 'number') {
      let handler = null;
      const timeoutId = window.setTimeout(() => {
        handler = run(token);
      }, delay);

      return () => {
        if (!func.isFunction(handler) && timeoutId) {
          window.clearTimeout(timeoutId);
        } else if (func.isFunction(handler)) {
          handler();
        }
      };
    } else {
      return run(token);
    }
  };
};
